import React, { useEffect } from 'react'
import { END } from 'redux-saga'
import { useSelector, useDispatch } from 'react-redux'
import dynamic from 'next/dynamic'
const cookie = require('cookie')
import { useRouter } from 'next/router'
import { wrapper } from '@/Store/index'
import { loadSelf } from '@fdn/profile_store'
import Router from 'next/router'
import MetaHeader from 'Containers/meta_header'
import Banner from 'Components/banner/banner_server';
import Sidebar from 'Components/sidebar';
import AuthorCard from 'Components/author_card';
import Env from 'Consts/env'
import { loadArticleAuthor } from '@/Store/article_author_store/lib/actions'
import { scrollToId, handleUrlArticle, ads_detik } from 'Helpers/utils'
import { fetchWithCache } from 'Helpers/fetch'
import { fetchAds } from 'Helpers/fetchAds'
import { loadPopularArticles } from '@/Store/popular_articles_store/lib/actions'
import { loadArticleVideo } from '@/Store/ArticleVideo/lib/actions'

const Breadcrumb = dynamic(() => import('@fdn/breadcrumb'))
const Pagination = dynamic(() => import('@fdn/pagination'), {
  ssr: false,
})
const Layout = dynamic(() => import('Containers/layout'), {
  ssr: true,
})
const ArticleCardHome = dynamic(() => import('Components/article_card_home'), {
  ssr: false,
})
const Section404 = dynamic(() => import('Components/error/404'), { ssr: false })
const ShimmerArticle = dynamic(() => import('Components/shimmer/articles'))

const AuthorArticle = (props) => {
  const isMobile = props.is_mobile
  const dispatch = useDispatch()
  const router = useRouter()
  const { page, userid } = router.query
  const storeData = useSelector((state) => state)


  const HandleUpdatePagination = (pageParam) => {
    scrollToId('heading')

    const path = window.location.pathname

    Router.push(
      {
        pathname: `/blog/author/${userid}`,
        query: {
          page: pageParam,
        },
      },
      `${path}?page=${pageParam}`,
      { shallow: true },
    )
  }

  useEffect(() => {
    if (router.isReady && typeof userid === "string") {
      dispatch(
        loadArticleAuthor({
          author_id: userid,
          page: page || '1',
          env: Env.HEADERS,
        }),
      )
    }
  }, [router.isReady, page, userid])

  useEffect(() => {
    dispatch(loadPopularArticles({ payload: { limit: 4 } }));
    dispatch(loadArticleVideo());
  }, []);

  return (
    <Layout
      home
      author_name={props.resAuthor?.data?.name ?? ""}
      page_type="articlelist"
      title={`${props.resAuthor?.data
        ? props.resAuthor?.data?.name
        : 'Editor'
        } Author at Femaledaily`}
      is_mobile={isMobile}
      self={storeData.storeSelf}
      ads_head={props.adsHead}
      ads_foot={props.adsFoot}
    >
      <MetaHeader
        url={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${userid}`}
        author={props.resAuthor?.data?.name}
      />
      <main id="main-content">
        <section id="page-heading">

          {(props.ads?.static1 || props.ads?.billboard) ?
            <Banner
              name={!!isMobile ? 'staticbanner1' : 'billboard'}
              placeholder={!!isMobile ? 'staticbanner1' : 'billboard'}
              is_mobile={isMobile}
              class_name="ads-billboard"
              dataAds={!!isMobile ? props.ads?.static1 : props.ads?.billboard}
            />
            : null
          }

          {props.resAuthor?.data?.id ? (
            <div className="container-author">
              <div className="row">
                <div className="col-12">
                  <Breadcrumb
                    is_mobile={isMobile}
                    breadcrumbs={['author']}
                    url={process.env.NEXT_PUBLIC_ROOT_DOMAIN}
                    fontFamily="Roboto"
                  />
                </div>
                <div className="col-12">
                  <div className="author-card-wrapper">
                    <AuthorCard
                      is_mobile={isMobile}
                      author_name={props.resAuthor?.data?.name}
                      author_description={props.resAuthor?.data?.bio}
                      author_image={props.resAuthor?.data?.image}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </section>
        <section id="page-content">
          <div className="container-author" id="heading">
            <div className="row-container">
              <div className="column-article">
                <div className="article-list">
                  {storeData.storeArticleAuthor?.status === 'fetch_result' &&
                    storeData.storeArticleAuthor?.data?.data?.length > 0 ? (
                    storeData.storeArticleAuthor?.data?.data?.map(
                      (item, idx) => (
                        <div key={String(idx)} className="article-card-wrapper">
                          <ArticleCardHome
                            is_mobile={isMobile}
                            is_sponsored={false}
                            font_title="Josefin Sans, sans-serif"
                            article={{
                              category: { name: item?.category?.[0]?.name || '' },
                              date: item?.created_at || '',
                              title: item?.title || '',
                              text: item?.excerpt || '',
                              image: item?.image || '',
                              url: handleUrlArticle(item?.url || ''),
                              author: { fullname: item?.author?.name || '' },
                            }}
                            url_category={
                              item?.category_slug
                                ? `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/category/${item.category_slug.replace(/[_]/g, '-')}`
                                : ''
                            }
                            type={!isMobile ? 'type-5' : 'type-2'}
                          />
                        </div>
                      ),
                    )
                  ) : storeData.storeArticleAuthor?.status === 'fetch_init' ||
                    storeData.storeArticleAuthor?.status === 'fetch_loading' ? (
                    [...Array(15).keys()].map((index) => (
                      <div key={String(index)} className="article-card-wrapper">
                        <ShimmerArticle isMobile={isMobile} />
                      </div>
                    ))
                  ) : (
                    <Section404 text="data" />
                  )}
                </div>
                {!!storeData.storeArticleAuthor?.data && (
                  <div className="pagination-wrapper">
                    <Pagination
                      is_mobile={isMobile}
                      page={page || '1'}
                      total_page={
                        storeData.storeArticleAuthor?.data?.pagination
                          ?.total_page
                      }
                      update_page={HandleUpdatePagination}
                    />
                    <style>
                      {`
                        .banner_container_billboard {
                          padding: 0 !important;
                        }
                        .paging-prev-text-active,
                        .paging-prev-text-inactive,
                        .paging-button,
                        .paging-button-dots,
                        .paging-button-active {
                          font-family: Roboto, sans-serif;
                          font-size: 12px;
                        }
                        .paging-totop,
                        .button-to-top {
                          display: none;
                        }
                        .paging-button,
                        .paging-button-active,
                        .paging-button-dots {
                          border: 1px solid #DFE3E8;
                          border-radius: 0;
                          margin: 0 3px;
                        }
                        .paging-button-active {
                          background-color: #DB284E;
                          color: #FFF;
                          font-weight: 600;
                          border-color: #DB284E;
                        }
                        .paging-list-number {
                          padding: 0 8px;
                        }
                        
										`}
                    </style>
                  </div>
                )}
              </div>
              {!isMobile ? (
                <div className="sidebar-body-wrapper">
                  <Sidebar
                    is_mobile={isMobile}
                    popularArticles={storeData?.storePopularArticles?.data}
                    beautyFiles={props.resBeautyFiles}
                    video={storeData?.storeArticleVideo}
                    ads={props.ads}
                  />
                </div>
              ) : (
                props.ads?.static2 ?
                  <div className="ads-bottom-wrapper">
                    <Banner
                      name="staticbanner2"
                      placeholder="staticbanner2"
                      is_mobile={isMobile}
                      class_name="ads-medium-rectangle2"
                      dataAds={props.ads?.static2}
                    />
                  </div>
                  : null
              )}
            </div>
          </div>
        </section>
      </main>
      <style>
        {`
          .paging-prev-text-active,
          .paging-prev-text-inactive,
          .paging-button,
          .paging-button-dots,
          .paging-button-active {
            font-family: Roboto, sans-serif;
            font-size: 12px;
          }
          .paging-totop,
          .button-to-top {
            display: none;
          }
          .paging-button,
          .paging-button-active,
          .paging-button-dots {
            border: 1px solid #DFE3E8;
            border-radius: 0;
            margin: 0 3px;
          }
          .paging-button-active {
            background-color: #DB284E;
            color: #FFF;
            font-weight: 600;
            border-color: #DB284E;
          }
          .paging-list-number {
            padding: 0 8px;
          }
        `}
      </style>
      <style jsx>
        {`
          #main-content {
            margin: 24px 0 62px;
          }

          #page-heading {
            padding-bottom: 24px;
            border-bottom: 1px solid #dfe3e8;
          }

          #page-content {
            padding-top: 24px;
          }
          .container-author {
            padding: 40px 0;
            max-width: 1220px;
            display: block;
            margin: 0 auto;
          }

          .col.article {
            //width: calc(100% - 380px);
            //max-width: calc(100% - 380px);
            //margin-right: 80px;
          }

          .col.sidebar-body-wrapper {
            width: 300px;
            max-width: 300px;
          }

          .article-card-wrapper {
            border-bottom: 1px solid #dfe3e8;
            margin-bottom: 20px;
          }

          .row-container {
            display: grid;
            grid-template-columns: auto 300px;
            gap: 60px;
          }
          @media (max-width: 800px) {
            #page-heading {
              padding-bottom: 0;
              border-bottom: 0;
            }
            .col.article {
              width: 100%;
              max-width: 100%;
              margin-right: 0;
            }
            .author-card-wrapper {
              margin: ${isMobile ? '0' : '0 12px'};
              border: ${isMobile ? '1px solid #dfe3e8' : 'none'};
              padding: ${isMobile ? '16px' : '0'};
            }
            .ads-bottom-wrapper {
              margin-top: 10px;
              width: 100%;
              text-align: center;
            }
            .row-container {
              display: grid;
              grid-template-columns: none;
              gap: 30px;
            }
            .container-author {
              padding: 20px 12px;
            }
            #main-content {
              margin: 24px 0 20px;
            }
          }
        `}
      </style>
    </Layout>
  )
}

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ store, req, res, query }) => {

    let userAgent
    if (req) {
      // if you are on the server and you get a 'req' property from your context
      userAgent = req.headers['user-agent'] // get the user-agent from the headers
    } else {
      userAgent = navigator.userAgent // if you are on the client you can access the navigator from the window object
    }

    let is_mobile =
      !!userAgent &&
      Boolean(
        userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
        ),
      )
    let cookies,
      authorization = null,
      usrname = null

    const isServer = !!req
    if (req.headers.cookie) {
      cookies = cookie.parse(req.headers.cookie)
      authorization = cookies.token
      usrname = cookies.usrname
    }

    if (authorization) {
      await store.dispatch(
        loadSelf({
          payload: {
            api_env: process.env.NEXT_PUBLIC_NODE_ENV,
            env: Env.HEADERS,
            Authorization: authorization,
            is_server: isServer,
            is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
          },
        }),
      )
    }

    store.dispatch(END)
    await store.sagaTask.toPromise()

    let site = is_mobile === true ? 'mobile' : 'desktop'

    const results = await Promise.allSettled([
      fetchWithCache(process.env.NEXT_PUBLIC_BEAUTY_FILES, 24),
      fetchWithCache(
        `${process.env.NEXT_PUBLIC_AUTHOR_DETAIL}/${query.userid}`,
      ),
      ads_detik(site, 'taghead'),
      ads_detik(site, 'tagfoot'),

      ...(is_mobile
        ? [fetchAds('staticbanner1', true), fetchAds('staticbanner2', true)]
        : [
          fetchAds('billboard', false),
          fetchAds('mediumrectangle1', false),
          fetchAds('mediumrectangle2', false),
        ]),
    ])

    const [BeautyFilesRes, AuthorRes, resAdsHead, resAdsFoot, ...adsRes] =
      results

    const adsHead =
      resAdsHead.status === 'fulfilled' ? resAdsHead.value ?? null : null

    const adsFoot =
      resAdsFoot.status === 'fulfilled' ? resAdsFoot.value ?? null : null

    const resBeautyFiles =
      BeautyFilesRes.status === 'fulfilled' ? BeautyFilesRes.value ?? {} : {}

    const resAuthor = AuthorRes.status === 'fulfilled' ? AuthorRes.value ?? [] : []

    let ads = {
      billboard: null,
      mediumrectangle1: null,
      mediumrectangle2: null,
      static1: null,
      static2: null,
    }

    if (is_mobile) {
      ads.static1 =
        adsRes[0]?.status === 'fulfilled' ? adsRes[0].value ?? null : null
      ads.static2 =
        adsRes[1]?.status === 'fulfilled' ? adsRes[1].value ?? null : null
    } else {
      ads.billboard =
        adsRes[0]?.status === 'fulfilled' ? adsRes[0].value ?? null : null
      ads.mediumrectangle1 =
        adsRes[1]?.status === 'fulfilled' ? adsRes[1].value ?? null : null
      ads.mediumrectangle2 =
        adsRes[2]?.status === 'fulfilled' ? adsRes[2].value ?? null : null
    }


    return {
      props: {
        is_mobile,
        resAuthor,
        resBeautyFiles,
        ads,
        adsHead,
        adsFoot,
      },
      // revalidate: 30, // In seconds
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
    }
  })

export default AuthorArticle
